import { render, staticRenderFns } from "./ReserveInfo.vue?vue&type=template&id=66fd2bad&lang=pug&"
import script from "./ReserveInfo.vue?vue&type=script&lang=js&"
export * from "./ReserveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports